import { HierarchyUtils } from '@inter-ikea-core/core';
import { EntityApi, PartKey } from '@inter-ikea-storageone/range';
import { duplicateEntity } from '@inter-ikea-storagetwo/range/dist/functions/duplicateEntity';
import SectionComponent from '@inter-ikea-storagetwo/range/dist/components/SectionComponent';
import LeftSideAttachedToComponent from '@inter-ikea-storagetwo/range/dist/components/LeftSideAttachedToComponent';
import RightSideAttachedToComponent from '@inter-ikea-storagetwo/range/dist/components/RightSideAttachedToComponent';
import RemovedLeftSideUnitComponent from '@inter-ikea-storagetwo/range/dist/components/RemovedLeftSideUnitComponent';
import RemovedRightSideUnitComponent from '@inter-ikea-storagetwo/range/dist/components/RemovedRightSideUnitComponent';
export class ElvarliEntityApi extends EntityApi {
    /**
     * @override Use duplicate function from storage two package
     */
    duplicate() {
        return duplicateEntity(this.core, this.placementService);
    }
    /**
     * @override handle sections where side units has been removed/merged
     */
    getObjectIdsByEntity(entity) {
        const includedObjectIds = super.getObjectIdsByEntity(entity);
        if (entity.hasComponent(SectionComponent.id)) {
            const removedSideUnitObjectIds = [];
            if (entity.hasComponent(RemovedLeftSideUnitComponent.id)) {
                // Left side unit has been removed from this section. Find merged side unit from neighbor section
                const leftAttachedSection = entity.getComponent(LeftSideAttachedToComponent.id)?.attachedTo;
                const mergedLeftSideUnit = leftAttachedSection &&
                    this.findEntityWithPartKey(HierarchyUtils.children(leftAttachedSection), PartKey.SIDE_UNIT_RIGHT);
                const leftSideObjectIds = mergedLeftSideUnit
                    ? super.getObjectIdsByEntity(mergedLeftSideUnit)
                    : [];
                removedSideUnitObjectIds.push(...leftSideObjectIds);
            }
            if (entity.hasComponent(RemovedRightSideUnitComponent.id)) {
                // Right side unit has been removed from this section. Find merged side unit from neighbor section
                const rightAttachedSection = entity.getComponent(RightSideAttachedToComponent.id)?.attachedTo;
                const mergedRightSideUnit = rightAttachedSection &&
                    this.findEntityWithPartKey(HierarchyUtils.children(rightAttachedSection), PartKey.SIDE_UNIT_LEFT);
                const rightSideObjectIds = mergedRightSideUnit
                    ? super.getObjectIdsByEntity(mergedRightSideUnit)
                    : [];
                removedSideUnitObjectIds.push(...rightSideObjectIds);
            }
            return [...includedObjectIds, ...removedSideUnitObjectIds];
        }
        return includedObjectIds;
    }
}
//# sourceMappingURL=ElvarliEntityApi.js.map